import React, { useState, useCallback } from "react";

import enTranslations from "@shopify/polaris/locales/en.json";
import { Provider } from "@shopify/app-bridge-react";
import {
  AppProvider,
  Page,
  Layout,
  Button,
  Card,
  TextField,
  FormLayout,
  Stack,
  Checkbox,
  Select,
  Banner,
} from "@shopify/polaris";
import LoadingButton from "./LoadingButton";

export default function StickersPage(props) {
  const { apiKey, host } = props;
  const config = { apiKey, host };

  const [input, setInput] = useState("");

  const [email, setEmail] = useState("operations@nona-source.com");

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // options
  const [excludeSoldOut, setExcludeSoldOut] = useState(false);
  const [onePerPage, setOnePerPage] = useState(false);
  const [stickersPerColor, setStickersPerColor] = useState("2");

  const options = { exclude_sold_out: excludeSoldOut, one_per_page: onePerPage, per_color: stickersPerColor };

  const handleSendFile = useCallback(
    async (template) => {
      setError(null);
      setSuccess(null);

      try {
        const response = await fetch("/api/products/file", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ input, email, template, options }),
        });

        if (response.ok) {
          setSuccess(`Your file is being generated and will be sent to ${email}.`);
        } else {
          let message = "Something went wrong. Please try again.";
          try {
            const data = await response.json();
            if (data && data.error) message = data.error;
          } catch (e) {
            // response had no JSON body
          }
          setError(message);
        }
      } catch (e) {
        setError("Could not reach the server. Please try again.");
      }
    },
    [input, email, options],
  );

  const disabled = input.trim().length === 0 || email.length === 0;

  return (
    <AppProvider i18n={enTranslations}>
      <Provider config={config}>
        <Page narrowWidth singleColumn title="Print files">
          <Layout>
            <Layout.Section>
              {error && (
                <div style={{ marginBottom: "1rem" }}>
                  <Banner status="critical" title="Error" onDismiss={() => setError(null)}>
                    <p>{error}</p>
                  </Banner>
                </div>
              )}
              {success && (
                <div style={{ marginBottom: "1rem" }}>
                  <Banner status="success" onDismiss={() => setSuccess(null)}>
                    <p>{success}</p>
                  </Banner>
                </div>
              )}
              <Card title="Send file to email address">
                <Card.Section>
                  <FormLayout>
                    <TextField
                      label="Tags, product IDs, or color IDs (comma separated)"
                      value={input}
                      onChange={(value) => setInput(value)}
                      helpText="Enter tags, product IDs (e.g. T20A00062), or color IDs (e.g. T20A00062.BLE1). Use a single format at a time."
                      placeholder="sale, new-in"
                      autoComplete="off"
                      multiline={2}
                    />
                    <TextField
                      label="Email address"
                      value={email}
                      onChange={(value, id) => setEmail(value)}
                      placeholder="jane.doe@email.com"
                      autoComplete="off"
                    />

                    <Checkbox label="Exclude sold out products" checked={excludeSoldOut} onChange={setExcludeSoldOut} />
                    <Stack alignment="trailing">
                      <LoadingButton
                        label="Send showroom slips"
                        onClick={() => handleSendFile("newSlips")}
                        disabled={disabled}
                      />
                      <Select
                        label="Number of stickers per color"
                        options={[
                          { label: "1", value: "1" },
                          { label: "2", value: "2" },
                          { label: "3", value: "3" },
                          { label: "4", value: "4" },
                        ]}
                        onChange={setStickersPerColor}
                        value={stickersPerColor}
                      />
                    </Stack>
                    <Stack alignment="center">
                      <LoadingButton
                        label="Send swatchcard"
                        onClick={() => handleSendFile("swatchcard")}
                        disabled={disabled}
                      />
                      <Checkbox label="One product per page" checked={onePerPage} onChange={setOnePerPage} />
                    </Stack>
                    <LoadingButton
                      label="Send stickers"
                      onClick={() => handleSendFile("stickers")}
                      disabled={disabled}
                    />
                  </FormLayout>
                </Card.Section>
              </Card>
            </Layout.Section>
          </Layout>
        </Page>
      </Provider>
    </AppProvider>
  );
}
